import {FormlyFieldConfig} from '@ngx-formly/core';

export const fields: FormlyFieldConfig[] = [
    {
        fieldGroup: [
            {
                key: 'email',
                type: 'input',
                templateOptions: {
                    label: 'Email',
                    placeholder: 'Email',
                    required: true,
                }
            },
            {
                key: 'password',
                type: 'input',
                templateOptions: {
                    type: 'password',
                    label: 'Password',
                    placeholder: 'Must be at least 3 characters',
                    required: true,
                    minLength: 3,
                },
            },
            {
                key: 'passwordConfirmation',
                type: 'input',
                templateOptions: {
                    type: 'password',
                    label: 'Confirm Password',
                    placeholder: 'Please re-enter your password',
                    required: true,
                },
            },
            {
                key: 'extra.name',
                type: 'input',
                templateOptions: {
                    label: 'Nombre',
                    placeholder: 'Nombre',
                    required: true,
                },
            },
            {
                key: 'extra.lastname',
                type: 'input',
                templateOptions: {
                    label: 'Apellido',
                    placeholder: 'Apellido',
                    required: true,
                }
            }
        ]
    }
];
